(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hp7O9", function(module, exports) {
const $cabad3ef0d2539a1$var$open = document.querySelector(".js-modal-open");
const $cabad3ef0d2539a1$var$close = document.querySelector(".js-modal-close");
const $cabad3ef0d2539a1$var$modal = document.querySelector(".js-backdrop");
$cabad3ef0d2539a1$var$open.addEventListener("click", $cabad3ef0d2539a1$var$openModal);
$cabad3ef0d2539a1$var$close.addEventListener("click", $cabad3ef0d2539a1$var$closeModal);
function $cabad3ef0d2539a1$var$openModal() {
    $cabad3ef0d2539a1$var$modal.classList.remove("is-hidden");
    document.body.classList.add("no-scroll");
    document.addEventListener("keydown", $cabad3ef0d2539a1$var$closeModalWithEsc);
    $cabad3ef0d2539a1$var$modal.addEventListener("click", $cabad3ef0d2539a1$var$closeModalBackdropClick);
}
function $cabad3ef0d2539a1$var$closeModal() {
    $cabad3ef0d2539a1$var$modal.classList.add("is-hidden");
    document.body.classList.remove("no-scroll");
    document.removeEventListener("keydown", $cabad3ef0d2539a1$var$closeModalWithEsc);
    $cabad3ef0d2539a1$var$modal.removeEventListener("click", $cabad3ef0d2539a1$var$closeModalBackdropClick);
}
function $cabad3ef0d2539a1$var$closeModalWithEsc(e) {
    if (e.code === "Escape") $cabad3ef0d2539a1$var$closeModal();
}
function $cabad3ef0d2539a1$var$closeModalBackdropClick(e) {
    if (e.target === $cabad3ef0d2539a1$var$modal) $cabad3ef0d2539a1$var$closeModal();
}

});

parcelRegister("i8Q71", function(module, exports) {
const $d35165bd5db5382a$var$homeLink = document.querySelector(".js-home-link");
const $d35165bd5db5382a$var$aboutLink = document.querySelector(".js-about-link");
const $d35165bd5db5382a$var$productsLink = document.querySelector(".js-products-link");
const $d35165bd5db5382a$var$contactsLink = document.querySelector(".js-contacts-link");
const $d35165bd5db5382a$var$aboutPage = document.querySelector(".about-container");
const $d35165bd5db5382a$var$productsPage = document.querySelector(".products-container");
const $d35165bd5db5382a$var$contactsPage = document.querySelector(".contacts-container");
if ($d35165bd5db5382a$var$aboutPage) $d35165bd5db5382a$var$aboutLink.classList.add("header-active-link");
else if ($d35165bd5db5382a$var$productsPage) $d35165bd5db5382a$var$productsLink.classList.add("header-active-link");
else if ($d35165bd5db5382a$var$contactsPage) $d35165bd5db5382a$var$contactsLink.classList.add("header-active-link");
else $d35165bd5db5382a$var$homeLink.classList.add("header-active-link");

});

parcelRequire("hp7O9");
parcelRequire("i8Q71");
class $8ebb4b9331d869f4$export$29b488039e3d4c2d {
    constructor(_status = 0, _text = "Network Error"){
        this.status = _status;
        this.text = _text;
    }
}


const $dc269d4a4c6a48d5$export$2b84f07db8df86ee = ()=>{
    if (typeof localStorage === "undefined") return;
    return {
        get: (key)=>Promise.resolve(localStorage.getItem(key)),
        set: (key, value)=>Promise.resolve(localStorage.setItem(key, value)),
        remove: (key)=>Promise.resolve(localStorage.removeItem(key))
    };
};


const $b2ff3e22672f6eac$export$6f57813fe9f31bf9 = {
    origin: "https://api.emailjs.com",
    blockHeadless: false,
    storageProvider: (0, $dc269d4a4c6a48d5$export$2b84f07db8df86ee)()
};


const $bc23224382981322$export$ecbd7d678ac4909b = (options)=>{
    if (!options) return {};
    // support compatibility with SDK v3
    if (typeof options === "string") return {
        publicKey: options
    };
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (options.toString() === "[object Object]") return options;
    return {};
};


const $f5c9566b4c02d8f7$export$2cd8252107eb640b = (options, origin = "https://api.emailjs.com")=>{
    if (!options) return;
    const opts = (0, $bc23224382981322$export$ecbd7d678ac4909b)(options);
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).publicKey = opts.publicKey;
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockHeadless = opts.blockHeadless;
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).storageProvider = opts.storageProvider;
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockList = opts.blockList;
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).limitRate = opts.limitRate;
    (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).origin = opts.origin || origin;
};





const $f9bc2fc89e115eb3$export$4a68059d3a005c64 = async (url, data, headers = {})=>{
    const response = await fetch((0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).origin + url, {
        method: "POST",
        headers: headers,
        body: data
    });
    const message = await response.text();
    const responseStatus = new (0, $8ebb4b9331d869f4$export$29b488039e3d4c2d)(response.status, message);
    if (response.ok) return responseStatus;
    throw responseStatus;
};



const $b332effacf7f6dd0$export$1f3bf48e9edf7d72 = (publicKey, serviceID, templateID)=>{
    if (!publicKey || typeof publicKey !== "string") throw "The public key is required. Visit https://dashboard.emailjs.com/admin/account";
    if (!serviceID || typeof serviceID !== "string") throw "The service ID is required. Visit https://dashboard.emailjs.com/admin";
    if (!templateID || typeof templateID !== "string") throw "The template ID is required. Visit https://dashboard.emailjs.com/admin/templates";
};


const $b3984aa6a558349f$export$80b670b04253020b = (templateParams)=>{
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    if (templateParams && templateParams.toString() !== "[object Object]") throw "The template params have to be the object. Visit https://www.emailjs.com/docs/sdk/send/";
};


const $7eb1a0d47e375e7d$export$b509da924d51a9a9 = (navigator)=>{
    return navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
};



const $717703854cefe791$export$a8135c843594e85b = ()=>{
    return new (0, $8ebb4b9331d869f4$export$29b488039e3d4c2d)(451, "Unavailable For Headless Browser");
};


const $0c4d6e3401e36ef1$export$1727dd877829fee8 = (list, watchVariable)=>{
    if (!Array.isArray(list)) throw "The BlockList list has to be an array";
    if (typeof watchVariable !== "string") throw "The BlockList watchVariable has to be a string";
};


const $8e8426a0737d7738$var$isBlockListDisabled = (options)=>{
    return !options.list?.length || !options.watchVariable;
};
const $8e8426a0737d7738$var$getValue = (data, name)=>{
    return data instanceof FormData ? data.get(name) : data[name];
};
const $8e8426a0737d7738$export$c7ab883573eb12a4 = (options, params)=>{
    if ($8e8426a0737d7738$var$isBlockListDisabled(options)) return false;
    (0, $0c4d6e3401e36ef1$export$1727dd877829fee8)(options.list, options.watchVariable);
    const value = $8e8426a0737d7738$var$getValue(params, options.watchVariable);
    if (typeof value !== "string") return false;
    return options.list.includes(value);
};



const $08c5a3d3320fcc57$export$b30160cec00781e = ()=>{
    return new (0, $8ebb4b9331d869f4$export$29b488039e3d4c2d)(403, "Forbidden");
};


const $e72894320f1329d3$export$88c64f8d5fea404b = (throttle, id)=>{
    if (typeof throttle !== "number" || throttle < 0) throw "The LimitRate throttle has to be a positive number";
    if (id && typeof id !== "string") throw "The LimitRate ID has to be a string";
};


const $4b26b710a5d6fdcb$var$getLeftTime = async (id, throttle, storage)=>{
    const lastTime = Number(await storage.get(id) || 0);
    return throttle - Date.now() + lastTime;
};
const $4b26b710a5d6fdcb$export$8b7f6a1a004faa27 = async (defaultID, options, storage)=>{
    if (!options.throttle || !storage) return false;
    (0, $e72894320f1329d3$export$88c64f8d5fea404b)(options.throttle, options.id);
    const id = options.id || defaultID;
    const leftTime = await $4b26b710a5d6fdcb$var$getLeftTime(id, options.throttle, storage);
    if (leftTime > 0) return true;
    await storage.set(id, Date.now().toString());
    return false;
};



const $280c23d2c9739cff$export$29b72785a20a20d9 = ()=>{
    return new (0, $8ebb4b9331d869f4$export$29b488039e3d4c2d)(429, "Too Many Requests");
};


const $f53c8666262364e4$export$89db4734f6c919c4 = async (serviceID, templateID, templateParams, options)=>{
    const opts = (0, $bc23224382981322$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $7eb1a0d47e375e7d$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $717703854cefe791$export$a8135c843594e85b)());
    (0, $b332effacf7f6dd0$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $b3984aa6a558349f$export$80b670b04253020b)(templateParams);
    if (templateParams && (0, $8e8426a0737d7738$export$c7ab883573eb12a4)(blockList, templateParams)) return Promise.reject((0, $08c5a3d3320fcc57$export$b30160cec00781e)());
    if (await (0, $4b26b710a5d6fdcb$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $280c23d2c9739cff$export$29b72785a20a20d9)());
    const params = {
        lib_version: "4.3.3",
        user_id: publicKey,
        service_id: serviceID,
        template_id: templateID,
        template_params: templateParams
    };
    return (0, $f9bc2fc89e115eb3$export$4a68059d3a005c64)("/api/v1.0/email/send", JSON.stringify(params), {
        "Content-type": "application/json"
    });
};





const $c85b29f732eee43a$export$ed692cabb252e59b = (form)=>{
    if (!form || form.nodeName !== "FORM") throw "The 3rd parameter is expected to be the HTML form element or the style selector of the form";
};









const $cd35917ebbcbd1a2$var$findHTMLForm = (form)=>{
    return typeof form === "string" ? document.querySelector(form) : form;
};
const $cd35917ebbcbd1a2$export$c13a0f9407ffb567 = async (serviceID, templateID, form, options)=>{
    const opts = (0, $bc23224382981322$export$ecbd7d678ac4909b)(options);
    const publicKey = opts.publicKey || (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).publicKey;
    const blockHeadless = opts.blockHeadless || (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockHeadless;
    const storageProvider = (0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).storageProvider || opts.storageProvider;
    const blockList = {
        ...(0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).blockList,
        ...opts.blockList
    };
    const limitRate = {
        ...(0, $b2ff3e22672f6eac$export$6f57813fe9f31bf9).limitRate,
        ...opts.limitRate
    };
    if (blockHeadless && (0, $7eb1a0d47e375e7d$export$b509da924d51a9a9)(navigator)) return Promise.reject((0, $717703854cefe791$export$a8135c843594e85b)());
    const currentForm = $cd35917ebbcbd1a2$var$findHTMLForm(form);
    (0, $b332effacf7f6dd0$export$1f3bf48e9edf7d72)(publicKey, serviceID, templateID);
    (0, $c85b29f732eee43a$export$ed692cabb252e59b)(currentForm);
    const formData = new FormData(currentForm);
    if ((0, $8e8426a0737d7738$export$c7ab883573eb12a4)(blockList, formData)) return Promise.reject((0, $08c5a3d3320fcc57$export$b30160cec00781e)());
    if (await (0, $4b26b710a5d6fdcb$export$8b7f6a1a004faa27)(location.pathname, limitRate, storageProvider)) return Promise.reject((0, $280c23d2c9739cff$export$29b72785a20a20d9)());
    formData.append("lib_version", "4.3.3");
    formData.append("service_id", serviceID);
    formData.append("template_id", templateID);
    formData.append("user_id", publicKey);
    return (0, $f9bc2fc89e115eb3$export$4a68059d3a005c64)("/api/v1.0/email/send-form", formData);
};


var $b3d61b8d8b0d7a23$export$2e2bcd8739ae039 = {
    init: $f5c9566b4c02d8f7$export$2cd8252107eb640b,
    send: $f53c8666262364e4$export$89db4734f6c919c4,
    sendForm: $cd35917ebbcbd1a2$export$c13a0f9407ffb567,
    EmailJSResponseStatus: $8ebb4b9331d869f4$export$29b488039e3d4c2d
};


const $9f6b213fe8735b98$var$SERVICE_ID = "service_sjub4p4";
const $9f6b213fe8735b98$var$TEMPLATE_ID = "template_aqc7han";
const $9f6b213fe8735b98$var$PUBLIC_KEY = "RCbRpHCE5ZYDG6Ivp";
const $9f6b213fe8735b98$var$contactsForm = document.querySelector(".contacts-form");
const $9f6b213fe8735b98$var$contactsBtn = document.querySelector(".js-contacts-btn");
const $9f6b213fe8735b98$var$contactsSuccess = document.querySelector(".js-contacts-success");
const $9f6b213fe8735b98$var$contactsError = document.querySelector(".js-contacts-error");
$9f6b213fe8735b98$var$contactsForm.addEventListener("submit", $9f6b213fe8735b98$var$sendMessage);
function $9f6b213fe8735b98$var$sendMessage(e) {
    e.preventDefault();
    $9f6b213fe8735b98$var$contactsBtn.innerHTML = `<span class="loader"></span>`;
    const form = e.target;
    const params = {
        userName: form.elements.name.value,
        userEmail: form.elements.email.value,
        userMessage: form.elements.message.value
    };
    (0, $b3d61b8d8b0d7a23$export$2e2bcd8739ae039).send($9f6b213fe8735b98$var$SERVICE_ID, $9f6b213fe8735b98$var$TEMPLATE_ID, params, {
        publicKey: $9f6b213fe8735b98$var$PUBLIC_KEY
    }).then(()=>{
        form.reset();
        if (!$9f6b213fe8735b98$var$contactsError.classList.contains("visually-hidden")) $9f6b213fe8735b98$var$contactsError.classList.add("visually-hidden");
        $9f6b213fe8735b98$var$contactsBtn.classList.add("visually-hidden");
        $9f6b213fe8735b98$var$contactsSuccess.classList.remove("visually-hidden");
    }, (err)=>{
        $9f6b213fe8735b98$var$contactsBtn.innerHTML = `<span>Send</span>`;
        $9f6b213fe8735b98$var$contactsError.classList.remove("visually-hidden");
        console.log(err.text);
    });
}



})();
//# sourceMappingURL=contacts.bd0d4483.js.map
